import React from "react";
import { BusinessUnit } from "../../../controls/BusinessUnit";

export const BusinessUnitControl: React.FC = () => {
  return <BusinessUnit />;
};
